export const tableMinHeight = '200px';
export const tableMaxHeight = 'calc(100vh - 204px)';
export const tableMaxHeightFooter = 'calc(100vh - 292px)';

// On bottom of RD page there is a link to legacy page => table becomes smaller
export const tableMaxHeightRD = 'calc(100vh - 300px)';
export const tableMaxHeightRDFooter = 'calc(100vh - 324px)';
